import { render, staticRenderFns } from "./PhysicalMentalDisorder.vue?vue&type=template&id=6e6b62de"
import script from "./PhysicalMentalDisorder.vue?vue&type=script&lang=js"
export * from "./PhysicalMentalDisorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports